export default __webpack_public_path__ + "static/media/Ballroll_00142.2646b03e.png";